/**
 * EmojiPicker (Sub-Batch BF-1 4.6)
 * Kompakter WhatsApp-Style-Picker mit Kategorien.
 * Keine externe Lib – pure CSS+React.
 */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Smile } from "lucide-react";

const EMOJI_CATEGORIES = [
  {
    key: "smileys",
    label: "Smileys",
    emojis: ["😀","😃","😄","😁","😆","😅","🤣","😂","🙂","🙃","😉","😊","😇","🥰","😍","🤩","😘","😗","😚","😙","😋","😛","😜","🤪","😝","🤑","🤗","🤭","🤫","🤔","🤐","🤨","😐","😑","😶","😏","😒","🙄","😬","🤥","😌","😔","😪","🤤","😴","😷","🤒","🤕","🤢","🤮","🥵","🥶","🥴","😵","🤯","🤠","🥳","😎","🤓","🧐","😕","😟","🙁","☹️","😮","😯","😲","😳","🥺","😦","😧","😨","😰","😥","😢","😭","😱","😖","😣","😞","😓","😩","😫","🥱","😤","😡","😠","🤬","😈","👿"],
  },
  {
    key: "hearts",
    label: "Herzen",
    emojis: ["❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎","💔","❣️","💕","💞","💓","💗","💖","💘","💝","💟"],
  },
  {
    key: "intim",
    label: "Intim",
    emojis: ["💋","👅","💦","🔥","🍑","🍆","💯","👀","😻","🌶️","🥵","🍓","🍯","💎","✨","🌸","🌺","🌷","🌹","💐","🦋"],
  },
  {
    key: "hands",
    label: "Hände",
    emojis: ["👋","🤚","✋","🖖","👌","🤌","🤏","✌️","🤞","🤟","🤘","🤙","👈","👉","👆","🖕","👇","☝️","👍","👎","👊","✊","🤛","🤜","👏","🙌","👐","🤲","🤝","🙏","💅","🤳","💪","🦾","🦵","🦶","👂","🦻","👃","🧠","🫀","🫁","🦷","🦴","👀","👁️"],
  },
  {
    key: "objects",
    label: "Objekte",
    emojis: ["🛍️","🎁","💌","📦","💳","💰","🏷️","🎀","💄","👗","👙","👘","🩱","🩲","🩳","👕","👚","🧥","👖","🧣","🧤","🧦","👞","👟","👠","👡","👢","🥿","👒","🎩","🧢","👑","💎","💍","🔑","🔒","🔓"],
  },
  {
    key: "symbols",
    label: "Symbole",
    emojis: ["✅","❌","⚠️","🚫","💯","💢","💥","💫","⭐","🌟","🎉","🎊","🎈","🍾","🥂","🍷","🍻","🍺","🥃","☕","🍵","🧋","🥤","🧉","🍹"],
  },
];

export default function EmojiPicker({ onPick }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("smileys");

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        title={t("emoji_picker.title")}
        data-testid="emoji-picker-trigger"
        className="h-8 px-2 bg-white border border-[#E5E5E5] hover:bg-[#F5F5F5] hidden sm:flex items-center gap-1"
      >
        <Smile size={14} /> <span className="text-xs">Emoji</span>
      </button>
    );
  }

  const active = EMOJI_CATEGORIES.find(c => c.key === tab);
  return (
    <div className="absolute z-50 mt-9 left-0 w-80 max-w-[95vw] bg-white border border-[#0A0A0A] shadow-xl">
      {/* Header */}
      <div className="flex items-center justify-between px-2 py-1 border-b border-[#E5E5E5]">
        <p className="text-[10px] font-bold text-[#0A0A0A] uppercase">Emojis</p>
        <button type="button" onClick={() => setOpen(false)} className="text-[#999] hover:text-[#0A0A0A] text-xs">✕</button>
      </div>
      {/* Tabs */}
      <div className="flex overflow-x-auto border-b border-[#E5E5E5] bg-[#FAFAFA]">
        {EMOJI_CATEGORIES.map(c => (
          <button key={c.key} type="button" onClick={() => setTab(c.key)}
            className={`px-2.5 py-1.5 text-[10px] whitespace-nowrap border-b-2 ${
              tab === c.key ? "border-[#0A0A0A] text-[#0A0A0A]" : "border-transparent text-[#999] hover:text-[#0A0A0A]"
            }`}>
            {c.label}
          </button>
        ))}
      </div>
      {/* Grid */}
      <div className="grid grid-cols-9 gap-0.5 p-2 max-h-44 overflow-y-auto">
        {active.emojis.map((emoji, i) => (
          <button
            key={i}
            type="button"
            onClick={() => onPick(emoji)}
            className="h-7 w-7 text-base hover:bg-[#F0F0F0] flex items-center justify-center"
            title={emoji}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
}
